import dashboard from './dashboard';
import user from './user';
import customers from './customers';
import packages from './packages';
// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, user, customers, packages]
};

export default menuItems;
